import { Animation, CommonAnimationData } from '@/modules/animation/slice';
// type
export enum AnimationType {
    STOP,
    CT_INIT,
    CT_ADD,
}
export type BaseAnimation = {
    animationType: AnimationType;
};
// init object
export const getNewAnimation = (hostId: number): Animation => ({
    HostId: hostId,
    Animation: {
        animationType: AnimationType.STOP,
    } as CommonAnimationData,
    Last: undefined,
});
